// extracted by mini-css-extract-plugin
export default {"link":"CustomLink_link__Uv7P-","primary":"CustomLink_primary__wwEOc","blank":"CustomLink_blank__japRu","underline":"CustomLink_underline__j3Plx"};